import React, { useEffect } from "react"
import {
  TextField,
  Grid,
  Divider,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material"
import PersonIcon from "@mui/icons-material/Person"
import PhoneIcon from "@mui/icons-material/Phone"
import EmailIcon from "@mui/icons-material/Email"
import LocationIcon from "@mui/icons-material/LocationOn"
import BadgeIcon from "@mui/icons-material/Badge"

const FormularioEntidadComponent = ({
  descripcionEntidad,
  setDescripcionEntidad,
  apellidoEntidad,
  setApellidoEntidad,
  dniCuitCuilEntidad,
  setdniCuitCuilEntidad,
  telefonoEntidad,
  setTelefonoEntidad,
  emailEntidad,
  setEmailEntidad,
  direccionEntidad,
  setDireccionEntidad,
  localidadEntidad,
  setLocalidadEntidad,
  provinciaEntidad,
  setProvinciaEntidad,
  idTipoEntidadEntidad,
  setIdTipoEntidadEntidad,
  idCondicionIvaEntidad,
  setIdCondicionIvaEntidad,
  tipoEntidades,
  condicionIva,
  errors,
  showCondicionIva = true,
  compact = false,
  tipoEntidadReadonly = false,
  tipoEntidadPredeterminado = null,
  disabled = false,
}) => {
  // Establecer tipo de entidad predeterminado al montar el componente
  useEffect(() => {
    if (tipoEntidadPredeterminado && !idTipoEntidadEntidad) {
      setIdTipoEntidadEntidad(tipoEntidadPredeterminado)
    }
  }, [tipoEntidadPredeterminado, idTipoEntidadEntidad, setIdTipoEntidadEntidad])

  const fieldStyle = {
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#5b5b5f",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#5b5b5f",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#5b5b5f",
    },
  }

  return (
    <Grid container spacing={3}>
      {/* Información Personal */}
      <Grid item xs={12}>
        <Typography variant={compact ? "subtitle1" : "h6"} sx={{ color: "#5b5b5f", fontWeight: 600, mb: 2 }}>
          Información Personal
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Nombre"
          variant="outlined"
          size="small"
          fullWidth
          value={descripcionEntidad}
          onChange={(e) => setDescripcionEntidad(e.target.value)}
          error={!!errors.descripcion}
          helperText={errors.descripcion}
          InputProps={{
            startAdornment: <PersonIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          required
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Apellido"
          variant="outlined"
          size="small"
          fullWidth
          value={apellidoEntidad}
          onChange={(e) => setApellidoEntidad(e.target.value)}
          InputProps={{
            startAdornment: <PersonIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="DNI/CUIT/CUIL"
          variant="outlined"
          size="small"
          fullWidth
          value={dniCuitCuilEntidad}
          onChange={(e) => setdniCuitCuilEntidad(e.target.value)}
          error={!!errors.dniCuitCuil}
          helperText={errors.dniCuitCuil}
          InputProps={{
            startAdornment: <BadgeIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          required
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormControl
          fullWidth
          size="small"
          error={!!errors.idTipoEntidad}
          sx={fieldStyle}
        >
          <InputLabel>Tipo de Entidad *</InputLabel>
          <Select
            value={idTipoEntidadEntidad}
            onChange={(e) => setIdTipoEntidadEntidad(e.target.value)}
            label="Tipo de Entidad *"
            disabled={disabled || tipoEntidadReadonly}
            sx={tipoEntidadReadonly || disabled ? {
              backgroundColor: "#f5f5f5",
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#e0e0e0",
              },
            } : {}}
          >
            {tipoEntidades.map((tipoEntidad) => (
              <MenuItem key={tipoEntidad.id} value={tipoEntidad.id}>
                {tipoEntidad.descripcion}
              </MenuItem>
            ))}
          </Select>
          {errors.idTipoEntidad && (
            <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
              {errors.idTipoEntidad}
            </Typography>
          )}
        </FormControl>
      </Grid>

      {showCondicionIva && (
        <Grid item xs={12} md={6}>
          <FormControl
            fullWidth
            size="small"
            sx={fieldStyle}
          >
            <InputLabel>Condición IVA</InputLabel>
            <Select
              value={idCondicionIvaEntidad}
              onChange={(e) => setIdCondicionIvaEntidad(e.target.value)}
              label="Condición IVA"
              disabled={disabled}
            >
              <MenuItem value="">
                <em>Sin seleccionar</em>
              </MenuItem>
              {condicionIva.map((condicion) => (
                <MenuItem key={condicion.id} value={condicion.id}>
                  {condicion.descripcion}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      )}

      {/* Información de Contacto */}
      <Grid item xs={12}>
        <Typography variant={compact ? "subtitle1" : "h6"} sx={{ color: "#5b5b5f", fontWeight: 600, mb: 2, mt: 2 }}>
          Información de Contacto
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Teléfono"
          variant="outlined"
          size="small"
          fullWidth
          value={telefonoEntidad}
          onChange={(e) => setTelefonoEntidad(e.target.value)}
          InputProps={{
            startAdornment: <PhoneIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Email"
          variant="outlined"
          size="small"
          fullWidth
          value={emailEntidad}
          onChange={(e) => setEmailEntidad(e.target.value)}
          error={!!errors.email}
          helperText={errors.email}
          InputProps={{
            startAdornment: <EmailIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          disabled={disabled}
        />
      </Grid>

      {/* Información de Ubicación */}
      <Grid item xs={12}>
        <Typography variant={compact ? "subtitle1" : "h6"} sx={{ color: "#5b5b5f", fontWeight: 600, mb: 2, mt: 2 }}>
          Información de Ubicación
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>

      <Grid item xs={12}>
        <TextField
          label="Dirección"
          variant="outlined"
          size="small"
          fullWidth
          value={direccionEntidad}
          onChange={(e) => setDireccionEntidad(e.target.value)}
          InputProps={{
            startAdornment: <LocationIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Localidad"
          variant="outlined"
          size="small"
          fullWidth
          value={localidadEntidad}
          onChange={(e) => setLocalidadEntidad(e.target.value)}
          InputProps={{
            startAdornment: <LocationIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          disabled={disabled}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextField
          label="Provincia"
          variant="outlined"
          size="small"
          fullWidth
          value={provinciaEntidad}
          onChange={(e) => setProvinciaEntidad(e.target.value)}
          InputProps={{
            startAdornment: <LocationIcon sx={{ color: "#5b5b5f", mr: 1 }} />,
          }}
          sx={fieldStyle}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  )
}

export default FormularioEntidadComponent
